import React from 'react'
import { browserHistory } from 'react-router'
import cookie from 'react-cookie'
import CSSModules from 'react-css-modules'
import styles from './logoLink.css'

const LogoLink = ({isTest, isAlfa}) => {
  if(isAlfa){
    return(<div>
      <img className={styles.alfaLogo}
           src="/assets/img/alfa/logo.png" alt=""
           onClick={() => {
             cookie.remove('token', {path: '/'})
             cookie.remove('txId', {path: '/'})
             cookie.remove('role', {path: '/'})
             cookie.remove('program', {path: '/'})
             cookie.remove('packageType', {path: '/'})
             cookie.remove('promoName', {path: '/'})
             cookie.remove('share', {path: '/'})
             //cookie.remove('general', { path: '/' })
             cookie.remove('userProgram', {path: '/'})
             cookie.remove('tester', {path: '/'})
             cookie.remove('abtest', {path: '/'})
             browserHistory.push('/')
           }}
      />
    </div>)
  } else {
    return (<svg className={styles.svgIconLogoWeb}
                 style={{cursor: 'pointer'}}
                 onClick={() => {
                   cookie.remove('token', {path: '/'})
                   cookie.remove('txId', {path: '/'})
                   cookie.remove('role', {path: '/'})
                   cookie.remove('program', {path: '/'})
                   cookie.remove('packageType', {path: '/'})
                   cookie.remove('promoName', {path: '/'})
                   cookie.remove('share', {path: '/'})
                   //cookie.remove('general', { path: '/' })
                   cookie.remove('userProgram', {path: '/'})
                   cookie.remove('tester', {path: '/'})
                   cookie.remove('abtest', {path: '/'})

                   if (isTest) {
                     window.location.href = 'https://gohero.todayme.ru/'
                   } else {
                     //window.location.href = '/'
                     browserHistory.push('/')
                   }

                 }}>
      <use xlinkHref="#ys_logo_web"></use>
    </svg>)
  }
}
export default CSSModules(LogoLink, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit/LogoLink.js